import axios from "axios";

// const baseURL = process.env.API_URL;
// const baseURL = process.env.LOCALHOST_URL;
const baseURL = 'https://apivendas.bairru.com.br/';

// const baseURL = 'http://localhost:3334/';

const api = axios.create({ baseURL });

// api.interceptors.request.use((config: AxiosRequestConfig) => {
//     config.headers["ngrok-skip-browser-warning"] = "bairru";
//     return config;
// });

export default api;
